import React from "react";

import "./PlayOverlay.scss";
import PlayIcon from "../../icons/PlayIcon";

export default function PlayOverlay() {
  return (
    <div className="PlayOverlay">
      <div className="PlayIconContainer">
        <PlayIcon />
      </div>
    </div>
  );
}
